module.exports = __webpack_public_path__ + "files/a1f3b2e88220927edd9680e1dd8da096.svg";